import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function normalizeConfig(config: any): any {
  const normalized: any = {};
  Object.keys(config || {}).forEach((key) => {
    const value = config[key];
    if (value === 'true') {
      normalized[key] = true;
    } else if (value === 'false') {
      normalized[key] = false;
    } else {
      normalized[key] = value;
    }
  });
  return normalized;
}

function bootstrapApp(): void {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

// Load runtime configuration from backend /environment endpoint, then bootstrap Angular
fetch('/environment')
  .then(response => {
    if (!response.ok) {
      throw new Error(`Failed to load /environment: ${response.status}`);
    }
    return response.json();
  })
  .then(config => {
    Object.assign(environment, normalizeConfig(config));
    bootstrapApp();
  })
  .catch(err => {
    console.error('Failed to load runtime environment configuration', err);
    // Fallback: bootstrap with empty/partial environment
    bootstrapApp();
  });
